import React, { useState, useEffect, useRef } from 'react'; 
import './scss/puzztime.scss';


import { initializeApp } from "firebase/app";
import { getAnalytics,logEvent } from "firebase/analytics";
import juegos from './assets/juegos.json';
import Header from './components/Header';
import SelecDia from './components/SelecDia';
import AbajoJuegos from './components/AbajoJuegos';

import { BrowserRouter, Routes, Route, Link, useLocation, useNavigate, useParams  } from 'react-router-dom';



/**
 * Ionic Dark Mode
 * -----------------------------------------------------
 * For more info, please see:
 * https://ionicframework.com/docs/theming/dark-mode
 */

/* import '@ionic/react/css/palettes/dark.always.css'; */
/* import '@ionic/react/css/palettes/dark.class.css'; */
//import '@ionic/react/css/palettes/dark.system.css';

/* Theme variables */
//import './theme/variables.css';

//setupIonicReact();


type DiaJuego = {
  fecha: string;
  textoFecha:string;
  medalla: number;
  offset: number;
};

/*const App: React.FC = () => (
  <div>
    <h2>Parejas</h2>
    <img src="public/iconos/caballo.png"/>
    <Carta></Carta>
  </div>
);*/
function ListaDias() {

     const navigate = useNavigate();

  const firebaseConfig = {
  apiKey: "AIzaSyCceVPpjBFbA_khqjXABlFtdex6wU6YWPM",
  authDomain: "everyday---deia.firebaseapp.com",
  projectId: "everyday---deia",
  storageBucket: "everyday---deia.firebasestorage.app",
  messagingSenderId: "789110585317",
  appId: "1:789110585317:web:5d01114092fe374edce10c",
  measurementId: "G-N0EC1VFRC5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const numDias=6;
const [iniciado, setIniciado] = useState(false);
const [dias, setDias] = useState<DiaJuego[]>([]);
const [juegoAct, setJuegoAct]=useState(juegos[0]);

if (!iniciado) {
    IniciarDias();
}

function IniciarDias() {
  var juegoAct=juegos[0];
  let params = useParams();
  for(var i=0; i<juegos.length;i++){
    if(juegos[i].escena==params.juego){
      setJuegoAct(juegos[i]);
      juegoAct=juegos[i];
    }
  }

  let diasAct =[];
  const dayNames = ["Domingo", "Lunes", "Martes","Miércoles","Jueves","Viernes","Sabado"];

  function crearDia(offset: number) {
    var today = new Date();
    today.setDate(today.getDate() - offset);
    var textoFecha="";
    if(offset==0){
      textoFecha="Hoy "+today.getDate();
    }else if(offset==1){
      textoFecha="Ayer "+today.getDate();
    }else{
      textoFecha = dayNames[today.getDay()] + " "+today.getDate();
    }
    var medalla=-2;
    var medallaConseguida=localStorage.getItem("medalla_"+juegoAct.escena+"_"+today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate());
    if(medallaConseguida!=null){
      medalla=Number(medallaConseguida);
    }
    return {fecha:today.toString(), textoFecha:textoFecha, medalla:medalla, offset:offset};
  }

  // Generar los primeros 5 días
  for (var i = 0; i < numDias - 1; i++) {
    diasAct.push(crearDia(i));
  }

  // El 6º botón: si los 5 primeros están todos jugados, buscar uno pendiente
  var hayPendiente = diasAct.some(d => d.medalla === -2);
  if (hayPendiente) {
    diasAct.push(crearDia(numDias - 1));
  } else {
    var encontrado = false;
    var offset = numDias - 1;
    while (offset < 60) {
      var dia = crearDia(offset);
      if (dia.medalla === -2) {
        diasAct.push(dia);
        encontrado = true;
        break;
      }
      offset++;
    }
    // Si no hay ninguno pendiente, mostrar el 6º día normal
    if (!encontrado) {
      diasAct.push(crearDia(numDias - 1));
    }
  }
  
  console.log(Route);

  //alert(params.juego);

  
  
  setDias(diasAct);
  setIniciado(true);
}



function ClickBack(){
  //navigate("/");
  AbrirLateral();
}

function AbrirLateral(){
    document.getElementById("lateral-juegos")!.style.left = "0px";
    document.getElementById("lateral-juegos")!.style.boxShadow = "4px 0 20px rgba(0,0,0,0.08)";
    document.getElementById("lateral-overlay")!.style.opacity = "1";
    document.getElementById("lateral-overlay")!.style.pointerEvents = "auto";
}


  

function ClickDia(dia: number){
    var diaAct=dias[dia];
    if(diaAct.medalla==-2){
      navigate("/"+juegoAct.escena+"/"+diaAct.offset);
    }else{

    }

  }

  

  




 return (
    <div className={"puzztime " + juegoAct.nombre}>

          {/* --------------------- HEADER --------------------- */}
          <Header nombre={juegoAct.nombre} color={juegoAct.color} clicked={() => ClickBack()} ></Header>

          <div className="dias-content">
            <p className="dias-content__subtitulo">Elige un día para jugar</p>
            <div className="dias-grid">
              {dias.map((diaAct, i) => (
                <SelecDia fecha={diaAct.fecha} fechaTxt={diaAct.textoFecha} medalla={diaAct.medalla} clicked={() => ClickDia(i)} icono={juegoAct.icono} key={i}></SelecDia>
              ))}
            </div>
          </div>

    <AbajoJuegos idJuegoAct={juegoAct.id} mostrarDias={false}></AbajoJuegos>
    </div>

    
  )
}

export default ListaDias;
